// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ArrowUpLeftIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ArrowUpLeftIcon" ref={forwardedRef} {...props}>
      <path d="m5.848 5.605 8.5.007v1.502L8.47 7.109l5.586 5.586-1.059 1.059L7.35 8.106l.001 6-1.495-.001z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ArrowUpLeftIcon = /* @__PURE__ */ Object.assign(
  ArrowUpLeftIconComponent,
  { displayName: 'ArrowUpLeftIcon' },
);
